import type { ConfluenceUpdatePageCommandProperties } from '@atlassian/rovo-content-bridge-api-commands/commands/confluence-update-page-command';

import type { DocumentImageUpdateCommandProcessor } from '../../stream-processors/update-image-command-processor';
import type { IMAGE_CREATE_KEY } from '../../types/command-manager';
import type { PageUpdateStrategy } from '../page-update-strategy';

type ImageUpdatePayload = Extract<
	ConfluenceUpdatePageCommandProperties,
	{ key: typeof IMAGE_CREATE_KEY }
>;

export class ImageUpdateStrategy implements PageUpdateStrategy {
	constructor(private processor: DocumentImageUpdateCommandProcessor) {}

	async process(payload: ConfluenceUpdatePageCommandProperties): Promise<void> {
		const { data, isStreamComplete, traceId, singleInstrumentationId } =
			payload as ImageUpdatePayload;
		await this.processor.streamChunk(data, isStreamComplete, traceId, singleInstrumentationId);
	}

	abort(reason?: 'user_abort' | 'aborted' | 'timeout'): void {
		// Skip timeout-based aborts — image generation naturally takes longer than
		// the inactivity timeout window (10s). Only abort on explicit user cancel.
		if (reason === 'timeout') {
			return;
		}
		this.processor.abortAndClearStreamingState();
	}
}
